import { textStyle } from '@themes/mixins';
import styled from 'styled-components';

import AutoComplete from '../../../../../AutoComplete';

export const StyledUnitPicker = styled(AutoComplete)`
  width: 65px;
  margin-left: 4px;

  & .MuiOutlinedInput-root {
    padding: 2px 4px;
  }
`;

export const StyledUnitLabel = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '14px',
    textAlign: 'left',
    weight: 400,
  })}
  padding: 5px;
  margin-right: 5px;
`;
